import { LinkItem } from 'components/eventView/filters/LinkItem';
import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import styled, { css } from 'styled-components/macro';

interface Props {
    selectedIndex: number;
    items: string[];
    className?: string;
    onSelected?: (index: number) => void;
}

export const ChoiceMenu = (props: Props): JSX.Element => {
    const ctxEventView = useContext(CtxEventView);

    return (
        <S_ChoiceMenu className={props.className} $isWide={ctxEventView.isWide}>
            {props.items.map((item, index) => {
                return (
                    <S_LinkItem
                        key={item}
                        title={item}
                        $isWide={ctxEventView.isWide}
                        choiceItem={index === props.selectedIndex ? 'fill' : 'border'}
                        onClick={() => {
                            if (props.onSelected) {
                                props.onSelected(index);
                            }
                        }}
                    />
                );
            })}
        </S_ChoiceMenu>
    );
};

const S_ChoiceMenu = styled.div<{ $isWide: boolean }>`
    display: flex;
    gap: 30px 40px;
    flex-wrap: wrap;
    width: 300px;
    justify-content: center;
    ${(props) => {
        if (props.$isWide) {
            return css`
                width: 100%;
            `;
        }
    }}
`;

const S_LinkItem = styled(LinkItem)<{ $isWide: boolean }>`
    min-width: 115px;
    ${(props) => {
        if (props.$isWide) {
            return css`
                width: unset;
                min-width: unset;
            `;
        }
    }}
`;
